export default "__VITE_ASSET__YCKldcyQ__"